/**
 * Where a transaction came from.
 *
 * One definition, imported by both transaction pages. It lived as an identical
 * copy in each of them, which is how `travel_` ended up classified as
 * `unknown` on both: the prefix was added to the backend and neither copy knew.
 */

export const IN_PERSON = 'in-person';
export const IN_APP = 'in-app';
export const EXTENSION = 'extension';
export const TRAVEL = 'travel';
export const RECEIPT = 'receipt';
export const STRIPE = 'stripe';
export const UNKNOWN = 'unknown';

/** The Wildfire application that reports the Safari extension. */
const WILDFIRE_EXTENSION_APP_ID = 554;

export const getTransactionSource = (transaction) => {
  const ext =
    transaction.external_txn_id && String(transaction.external_txn_id);

  // Prefix first: these are unambiguous, and a travel booking carries a
  // merchant name that would otherwise match one of the vendor tests below.
  if (ext && ext.startsWith('travel_')) return TRAVEL;
  if (ext && ext.startsWith('attraction_')) return TRAVEL;
  if (ext && ext.startsWith('stripe_checkout_')) return STRIPE;
  if (ext && ext.startsWith('receipt-')) return RECEIPT;

  if (
    transaction.wildfire_merchant_id ||
    transaction.wildfire_merchant_name ||
    (transaction.raw_descriptor &&
      transaction.raw_descriptor.includes('wildfire'))
  ) {
    return transaction.wildfire_application_id === WILDFIRE_EXTENSION_APP_ID
      ? EXTENSION
      : IN_APP;
  }

  if (
    transaction.olive_merchant_id ||
    transaction.olive_merchant_name ||
    (transaction.raw_descriptor && transaction.raw_descriptor.includes('olive'))
  ) {
    return IN_PERSON;
  }

  return UNKNOWN;
};

export const SOURCE_LABELS = {
  [IN_APP]: 'In-app',
  [IN_PERSON]: 'In-person',
  [EXTENSION]: 'Extension',
  [TRAVEL]: 'Travel',
  [RECEIPT]: 'Receipt review',
  [STRIPE]: 'Direct (Stripe)',
  [UNKNOWN]: 'Unknown',
};

/**
 * The filter list. Receipt and Stripe are deliberately absent: neither has ever
 * produced a production transaction, and `getTransactionSource` still labels
 * them correctly in the table if one appears.
 */
export const SOURCE_FILTER_OPTIONS = [
  { value: 'all', label: 'All Sources' },
  { value: IN_APP, label: SOURCE_LABELS[IN_APP] },
  { value: IN_PERSON, label: SOURCE_LABELS[IN_PERSON] },
  { value: EXTENSION, label: SOURCE_LABELS[EXTENSION] },
  { value: TRAVEL, label: SOURCE_LABELS[TRAVEL] },
];
